<template>
    <b-card-text>

        <container-loader v-if="!isFilesLoaded"></container-loader>
<!--            <table-functions @search="(val)=>{search = val}"></table-functions>-->


        <files-upload  :clickable="false" :overlay="false" @hide="showUpload = false" :show="true">
            <template slot="content">

            <files-table :items="getFiles" :search="search" @forceUpdateFiles="fetchFiles"></files-table>
            </template>
        </files-upload>

    </b-card-text>
</template>

<script>
  // import TableFunctions from '@/components/TableFunctions.vue';
  import FilesTable from '@/components/files/FilesTable.vue';
  import {mapActions, mapGetters} from 'vuex'
  import FilesUpload from "@/components/apps/upload/FilesUpload";
  export default {
    name: "FilesTab",
    props: ['search'],
    components: {
      FilesUpload,
      FilesTable
    },
    computed: {
      ...mapGetters(['getFiles','isProjectsLoaded', 'isFilesLoaded'])
    },
    data() {
      return {
        polling: null
      }
    },
    methods: {
      ...mapActions(['fetchFiles','fetchProjects'])
    },
    created() {
      this.fetchFiles().then(() => {
        //TODO: refactor. Quick solution for switching between tabs with file highlighting
        if (!this.isProjectsLoaded) {
          this.fetchProjects();
        }
      })
      this.polling = setInterval(() => {
        this.fetchFiles();
      }, 3000);
    },
    beforeDestroy () {
      clearInterval(this.polling)
    }
  }
</script>

<style scoped>

</style>

